<template>


</template>

<script>

import Storage from '@/helpers/storage'

import Share from '@/modules/share'
import Tracking from '@/modules/tracking'
import UserAgent from '@/modules/userAgent'
import UserFlow from '@/modules/userFlow'

export default {

    name: 'save-the-planet',


    data() {
        return {}
    },

    created() {

        Tracking.saveTracking(this.$route.query)

        UserFlow.setPage(this, 'save-the-planet')

    },

    mounted() {

        const partnerCode = this.$route.query.partnerCode

        if (partnerCode) {
            Storage.setItem('partnerCode', partnerCode)
        }

        this.redirect()

    },

    methods: {

        redirect() {

            if (UserAgent.is.mobile()) {

                if (UserAgent.is.ios()) {

                    Share.downloadIosApp(false)

                } else if (UserAgent.is.android()) {

                    Share.downloadAndroidApp(false)

                }

            }

            this.$router.push({path: '/'})
                .catch(() => {})

        }

    }
}
</script>

<style lang="scss" scoped>

</style>
